/* VARENO — sticky header, hero slider, scroll reveal, quick add.
   Egyszer töltődik be; minden szekció önállóan is működik nélküle (csak animáció nélkül). */
(function () {
  'use strict';

  /* ---- sticky fejléc ---- */
  function initHeader() {
    var h = document.querySelector('[data-vr-header]');
    if (!h) return;
    var onScroll = function () {
      h.classList.toggle('vr-solid', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- mobil menü ---- */
  function initDrawer() {
    var btn = document.querySelector('[data-vr-menu]');
    var drawer = document.querySelector('[data-vr-drawer]');
    if (!btn || !drawer || btn.dataset.vrBound) return;
    btn.dataset.vrBound = '1';

    function open() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('vr-open'); });
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('.vr-drawer__panel a');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('vr-open');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 450);
      btn.focus();
    }
    btn.addEventListener('click', open);
    drawer.querySelectorAll('[data-vr-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  /* ---- hero diavetítés ---- */
  function initHero(root) {
    var slides = root.querySelectorAll('.vr-hero__slide');
    var dots = root.querySelector('[data-vr-dots]');
    if (slides.length < 2 || !dots) return;
    var cur = 0, timer = null;
    var delay = parseInt(root.getAttribute('data-vr-interval'), 10) || 6500;

    dots.innerHTML = '';
    for (var i = 0; i < slides.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', (i + 1) + '. dia');
      if (i === 0) b.className = 'vr-on';
      (function (idx) { b.addEventListener('click', function () { go(idx); restart(); }); })(i);
      dots.appendChild(b);
    }

    function go(i) {
      slides[cur].classList.remove('vr-on');
      dots.children[cur].classList.remove('vr-on');
      cur = i;
      slides[i].classList.add('vr-on');
      dots.children[i].classList.add('vr-on');
      var im = slides[i].querySelector('img');
      if (im) { im.style.animation = 'none'; void im.offsetWidth; im.style.animation = ''; }
    }
    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(function () { go((cur + 1) % slides.length); }, delay);
    }
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) restart();
  }

  /* ---- scroll reveal ---- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.vr-reveal:not(.vr-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('vr-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vr-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  /* ---- gyors kosárba (Ajax Cart API) ---- */
  function initQuickAdd(scope) {
    (scope || document).querySelectorAll('[data-vr-add]').forEach(function (btn) {
      if (btn.dataset.vrBound) return;
      btn.dataset.vrBound = '1';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var id = btn.getAttribute('data-vr-add');
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () {
            btn.textContent = '✓ Kosárban';
            document.dispatchEvent(new CustomEvent('vareno:added'));
            // Dawn kosár-fiók frissítése, ha van
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              fetch(window.location.pathname + '?sections=cart-drawer').catch(function () {});
            }
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
          })
          .catch(function () {
            btn.textContent = 'Hiba — próbáld újra';
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
          });
      });
    });
  }


  /* ---- videó: feltöltött fájl (elsődleges) vagy TikTok (tartalék) ---- */
  function initVideo(scope) {
    (scope || document).querySelectorAll('[data-vr-vid]').forEach(function (box) {
      if (box.dataset.vrBound) return;
      box.dataset.vrBound = '1';

      var btn = box.querySelector('[data-vr-play]');
      var el = box.querySelector('video');
      var auto = box.classList.contains('vr-vid--auto');

      /* --- feltöltött videó --- */
      if (el) {
        if (btn) {
          btn.addEventListener('click', function () {
            if (auto) {
              el.muted = !el.muted;
              box.classList.toggle('vr-vid--on', !el.muted);
              btn.setAttribute('aria-label', el.muted ? 'Hang bekapcsolása' : 'Némítás');
              if (el.paused) el.play().catch(function () {});
            } else if (el.paused) {
              el.play().catch(function () {});
            } else {
              el.pause();
            }
          });
          el.addEventListener('play', function () { box.classList.add('vr-vid--playing'); });
          el.addEventListener('pause', function () { if (!auto) box.classList.remove('vr-vid--playing'); });
        }

        /* a videón bárhol kattintva szünet/indítás */
        el.addEventListener('click', function () {
          if (auto) return;
          if (el.paused) { el.play().catch(function () {}); } else { el.pause(); }
        });

        /* időbélyegre kattintva a videó odaugrik */
        var root = box.closest('.vr-ritual') || document;
        root.querySelectorAll('[data-vr-seek]').forEach(function (s) {
          s.addEventListener('click', function () {
            var t = parseFloat(s.getAttribute('data-vr-seek'));
            if (isNaN(t)) return;
            el.currentTime = t;
            if (el.paused) el.play().catch(function () {});
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        });

        /* görgetésre indul, kigörgetve megáll.
           A fájl csak akkor kezd letöltődni, amikor a látogató tényleg odaér. */
        var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var thrifty = navigator.connection && navigator.connection.saveData;
        var started = false;

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                if (!auto || calm || thrifty) return;
                if (!started) { started = true; el.preload = 'auto'; }
                if (el.paused) {
                  var pr = el.play();
                  if (pr && pr.catch) {
                    pr.catch(function () {
                      /* a böngésző nem engedte (energiatakarékos mód) —
                         visszakapja a nagy lejátszás gombot */
                      box.classList.remove('vr-vid--auto');
                      auto = false;
                    });
                  }
                }
              } else if (!el.paused) {
                el.pause();
              }
            });
          }, { threshold: 0.4 }).observe(el);
        }
        return;
      }

      /* --- tartalék: TikTok beágyazás, csak kattintásra --- */
      var id = box.getAttribute('data-vr-tiktok');
      if (!btn || !id || !/^[0-9]+$/.test(id)) return;
      btn.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.tiktok.com/embed/v2/' + id + '?autoplay=1';
        f.title = 'VARENO';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        f.loading = 'lazy';
        box.appendChild(f);
        btn.remove();
        var meta = box.querySelector('.vr-vid__meta');
        if (meta) meta.remove();
      });
    });
  }

  /* ---- tobb variansot egyszerre a kosarba ---- */
  function initAddMany(scope) {
    (scope || document).querySelectorAll('[data-vr-add-many]').forEach(function (btn) {
      if (btn.dataset.vrBound) return;
      btn.dataset.vrBound = '1';
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-vr-add-many') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        var label = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = '\u2026';
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () {
            btn.textContent = '\u2713 Kosarban';
            document.dispatchEvent(new CustomEvent('vareno:added'));
            setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 2400);
          })
          .catch(function () {
            btn.textContent = 'Hiba \u2014 probald ujra';
            setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 2400);
          });
      });
    });
  }


  /* ---- katalógus: rendezés azonnal érvényesül (JS nélkül gomb van) ---- */
  function initSort(scope) {
    (scope || document).querySelectorAll('[data-vr-sort]').forEach(function (form) {
      if (form.dataset.vrBound) return;
      form.dataset.vrBound = '1';
      form.addEventListener('change', function (e) {
        if (e.target.matches('select')) form.submit();
      });
    });
  }


  /* ---- vélemény karusszel ---- */
  function initCarousel(scope) {
    (scope || document).querySelectorAll('[data-vr-rc-track]').forEach(function (track) {
      if (track.dataset.vrBound) return;
      track.dataset.vrBound = '1';

      var root = track.closest('.vr-rc');
      if (!root) return;
      var prev = root.querySelector('[data-vr-rc-prev]');
      var next = root.querySelector('[data-vr-rc-next]');
      var fill = root.querySelector('[data-vr-rc-fill]');
      var nav = root.querySelector('[data-vr-rc-nav]');

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        /* egy képernyőre fér: elrejtjük a vezérlést */
        if (nav) nav.hidden = max < 4;
        if (root.querySelector('.vr-rc__bar')) {
          root.querySelector('.vr-rc__bar').hidden = max < 4;
        }
        if (max < 4) return;

        var ratio = track.scrollLeft / max;
        if (fill) {
          var vis = track.clientWidth / track.scrollWidth;
          var w = Math.max(vis * 100, 8);
          fill.style.width = w + '%';
          fill.style.left = (ratio * (100 - w)) + '%';
        }
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      /* billentyűzet: nyilakkal is lapozható */
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
      });

      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; sync(); });
      }, { passive: true });

      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
      window.addEventListener('resize', sync);
      sync();
    });
  }


  /* ---- termékoldal: galéria, variánsok, mennyiség, ragadós sáv ---- */
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-vr-product]').forEach(function (root) {
      if (root.dataset.vrBound) return;
      root.dataset.vrBound = '1';

      var wrap = root.parentElement;
      var track = root.querySelector('[data-vr-gal-track]');
      var slides = root.querySelectorAll('[data-vr-gal-slide]');
      var thumbs = root.querySelectorAll('[data-vr-gal-go]');
      var dots = root.querySelectorAll('[data-vr-gal-dots] i');

      /* --- galéria: asztali gépen csere, telefonon swipe --- */
      function showSlide(i) {
        slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-vr-gal-go'), 10);
          showSlide(i);
          /* telefonon a sáv oda is görög */
          if (track && track.scrollWidth > track.clientWidth + 4 && slides[i]) {
            track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        });
      });
      if (track) {
        var graf;
        track.addEventListener('scroll', function () {
          if (graf) return;
          graf = requestAnimationFrame(function () {
            graf = null;
            if (track.scrollWidth <= track.clientWidth + 4) return;
            var i = Math.round(track.scrollLeft / track.clientWidth);
            dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
          });
        }, { passive: true });
      }

      /* --- mennyiség --- */
      var qty = root.querySelector('[data-vr-qty] input');
      var down = root.querySelector('[data-vr-qty-down]');
      var up = root.querySelector('[data-vr-qty-up]');
      if (qty && down && up) {
        down.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
        up.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      }

      /* --- variánsok --- */
      var dataEl = wrap ? wrap.parentElement.querySelector('[data-vr-variants]') : null;
      if (!dataEl) dataEl = document.querySelector('[data-vr-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

      var idInput = root.querySelector('[data-vr-variant-id]');
      var priceEl = root.querySelector('[data-vr-price]');
      var stockEl = root.querySelector('[data-vr-stock]');
      var atc = root.querySelector('[data-vr-atc]');
      var atcText = root.querySelector('[data-vr-atc-text]');
      var stickyPrice = document.querySelector('[data-vr-sticky-price]');
      var opts = root.querySelectorAll('[data-vr-opt-input]');

      function chosen() {
        var out = [];
        root.querySelectorAll('[data-vr-option]').forEach(function (g) {
          var c = g.querySelector('input:checked');
          out.push(c ? c.value : null);
        });
        return out;
      }

      function update() {
        if (!variants.length || !opts.length) return;
        var want = chosen();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return want[i] == null || o === want[i]; });
        });
        if (!match) return;

        if (idInput) idInput.value = match.id;
        if (priceEl) {
          priceEl.innerHTML = (match.on_sale > 0 ? '<s>' + match.compare + '</s>' : '') + match.price;
        }
        if (stickyPrice) stickyPrice.textContent = match.price;
        if (atc) atc.disabled = !match.available;
        if (atcText && atc) {
          atcText.textContent = match.available
            ? (atc.getAttribute('data-label-add') || atcText.getAttribute('data-add') || atcText.textContent)
            : 'Elfogyott';
        }
        if (stockEl) stockEl.classList.toggle('is-out', !match.available);

        /* a variáns saját képére ugrunk, ha van */
        if (match.media_id) {
          slides.forEach(function (s, n) {
            if (s.getAttribute('data-vr-media-id') === String(match.media_id)) showSlide(n);
          });
        }
        /* a cím sorban marad a megosztott linkkel */
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', match.id);
          history.replaceState({}, '', u);
        }
      }

      /* az eredeti gombfeliratot elmentjük, hogy vissza tudjuk írni */
      if (atcText) atcText.setAttribute('data-add', atcText.textContent.trim());
      opts.forEach(function (i) { i.addEventListener('change', update); });

      /* --- ragadós mobil sáv: akkor jön elő, ha a gomb kigörgött --- */
      var bar = wrap ? wrap.querySelector('[data-vr-stickybuy]') : null;
      if (bar && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { bar.hidden = e.isIntersecting; });
        }, { threshold: 0 }).observe(atc);
      }
    });
  }

  function boot(scope) {
    initHeader();
    initDrawer();
    (scope || document).querySelectorAll('[data-vr-hero]').forEach(initHero);
    initReveal(scope);
    initQuickAdd(scope);
    initVideo(scope);
    initAddMany(scope);
    initSort(scope);
    initCarousel(scope);
    initProduct(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme editor: szekció újrarenderelés után újrainicializálás */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
